import React from "react";
import PropTypes from "prop-types";
import styles from "./Tabs.module.styl";

export default function Tabs({ children }) {
    return <div className={styles.container}>{children}</div>;
}

Tabs.propTypes = {
    children: PropTypes.node,
};
